<template>
  <div>
    <el-row type="flex" class="row-bg" justify="center">
      <h1>Reporte de Productividad por mes</h1>
    </el-row>

    <el-row>
      <rabbey-table-3
        :border="true"
        :stripe="true"
        :actions="TaskActions"
        @rtable-push-action="handlePushAction"
        :loading="loadingData"
        :data="FilteredTasks"
        :columns="TaskColumns"
        show-summary
        sum-text="Tiempo Total"
        :summary-method="getSummaries"
        page_Size="500"
        :pageSizes="[500, 1000]"
      />
    </el-row>
  </div>
</template>

<script>
import { columns } from "@/columns/ProductiveHoursReportByMonths/ProductiveHoursReportByMonths";

export default {
  name: "ProductiveHoursReportByMonth",
  data() {
    return {
      FilteredTasks: [],
      TaskColumns: columns(this),
      TaskActions: [],
      loadingData: false,
      filters: {
        Responsible: 0,
        Direction: 0,
        Deparment: 0,
        Year: 0,
        Month: 0,
        Week: 0,
        Type: 0
      }
    };
  },
  mounted() {
    this.getTasksForReport();
  },
  methods: {
    async getTasksForReport() {
      // Fetch or compute tasks for the report
      this.loadingData = true;
      await this.$http
        .get("api/ReporteGestion/Get_Productive_Hours_Report_By_Month", {
          params: {
            ResponsableID: this.filters.Responsible,
            DirecctionID: this.filters.Direction,
            DeparmentId: this.filters.Deparment,
            Year: this.filters.Year,
            Month: this.filters.Month,
            WeekOnMothSelected: this.filters.Week,
            Type: this.filters.Type
          }
        })
        .then((response) => {
          this.FilteredTasks = response.data;
        })
        .catch((error) => {
          console.error("Error fetching tasks:", error);
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    handlePushAction() {},
    getSummaries() {}
  }
};
</script>

<style lang="scss" scoped></style>
